import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '11.38 6.5199'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M21.1001 1.54004C21.1001 1.54004 17.6501 2.97006 11.3701 2.97006C5.09014 2.97006 1.64014 1.54004 1.64014 1.54004C5.21014 9.21004 9.08014 10.6501 11.3601 10.6501C13.6401 10.6501 17.5301 9.21004 21.1001 1.54004Z"
          fill="white"
        />
        <path
          d="M11.37 12.3599C4.01 12.3599 0 0.679932 0 0.679932C0 0.679932 5.37 1.94992 11.38 1.94992C17.39 1.94992 22.76 0.679932 22.76 0.679932C22.76 0.679932 18.72 12.3599 11.37 12.3599ZM2.7 2.89993C5.92 8.86993 9.66 9.81992 11.36 9.81992C13.06 9.81992 16.85 8.86993 20.07 2.89993C18.39 3.31993 15.07 3.79993 11.37 3.79993C7.67 3.80993 4.38 3.31993 2.7 2.89993Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
